/* AthleteSwap Verkaufen — Kategorie-/Fragen-/Foto-Konfiguration.
   Datengetrieben statt hart verdrahtet (analog assets/as-fit-daten.js),
   damit sich Kategorien, Fragen und Fotoaufgaben ohne Code-Änderung pflegen
   lassen und sich später weitere Sportarten ergänzen lassen.

   Bewusst KEIN Helm — Athlete Swap kauft Helme aus Sicherheitsgründen
   grundsätzlich nicht an.

   Leitprinzip für ALLE Texte hier: Der Verkäufer hat kein Eishockeywissen.
   Keine Fachbegriffe (kein "TUUK", "Holder", "Fit 2", "Flex"), keine
   Messaufgaben, keine Schulnoten. Alles, was wir aus einem Foto ableiten
   können (Kufenresthöhe, Rost, Modell, Größe), wird NICHT gefragt, sondern
   fotografiert. Jede Frage lässt sich mit Ja/Nein/Weiß ich nicht
   beantworten.

   Jede Kategorie:
   - einheit: Zähleinheit für die Artikelnavigation ("Paar" / "Stück").
   - marken: Markenchips, nur wenn Marke für die Einschätzung relevant ist.
   - brauchtModell / brauchtGroesse: schalten die jeweiligen Felder frei,
     beide immer mit "Weiß ich nicht"-Ausweg.
   - modellHinweis / groesseHinweis: sagen dem Verkäufer, WO er die Angabe
     am Artikel findet, statt Vorwissen vorauszusetzen.
   - zustandsfragen: Ja/Nein/Weiß ich nicht, niemals Schulnoten.
     "hinweis" entschärft Fragen, die man ohne Wissen nicht sicher
     beantworten kann.
   - fotosStandard: immer nötig. Jede Aufgabe hat "was" (was soll im Bild
     sein) und "warum" (wozu wir es brauchen) — je ein kurzer Satz.
   - fotosBedingt: nur wenn "wenn"-Bedingung zutrifft (Progressive
     Disclosure) — "frage"+"antworten" prüft eine Zustandsfrage,
     "modellUnbekannt"/"groesseUnbekannt" prüft die jeweiligen Flags.
   - spezialfall: true = kein Frage-Screen, direkt zu Kurznotiz + Fotos,
     geht in die manuelle Prüfung (Torwartausrüstung, Sonstiges). */
(function () {
  var KATEGORIEN = [
    {
      id: "schlittschuhe",
      name: "Schlittschuhe",
      einheit: "Paar",
      marken: ["Bauer", "CCM", "TRUE", "Graf"],
      brauchtModell: true,
      modellHinweis: "Steht meist seitlich außen auf dem Schuh.",
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. 38, 5.5 oder Junior 3",
      groesseHinweis: "Steht meist innen an der Lasche oder unten auf der Sohle.",
      zustandsfragen: [
        { id: "riss", frage: "Ist irgendwo etwas gerissen oder gebrochen?" },
        { id: "ferse", frage: "Ist das Innenfutter an der Ferse durchgescheuert oder hat ein Loch?" },
        {
          id: "fersenkappe",
          frage: "Wie stabil ist die Ferse hinten?",
          hinweis: "Halte den Schuh fest und drück den harten Teil hinten mit dem Daumen nach innen.",
          optionen: [
            { wert: "fest", label: "Bleibt fest" },
            { wert: "gibt_nach", label: "Gibt etwas nach" },
            { wert: "weich", label: "Lässt sich leicht eindrücken" },
            { wert: "unsicher", label: "Weiß ich nicht" }
          ]
        },
        {
          id: "sonstiges",
          typ: "text",
          frage: "Ist sonst noch etwas beschädigt?",
          hinweis: "Nur wenn dir etwas auffällt — sonst einfach leer lassen.",
          platzhalter: "z. B. Schnürsenkel fehlen, Zunge eingerissen"
        }
      ],
      fotosStandard: [
        {
          id: "gesamt",
          titel: "Beide Schlittschuhe von außen",
          was: "Stell beide nebeneinander und fotografiere sie von der Seite.",
          warum: "So erkennen wir Modell und den allgemeinen Zustand."
        },
        {
          id: "kufe_seitlich",
          titel: "Kufe von der Seite",
          was: "Fotografiere einen Schuh seitlich, sodass das komplette Metall unten im Bild ist.",
          warum: "Daran sehen wir, wie viel von der Kufe noch übrig ist."
        },
        {
          id: "innenfutter",
          optional: true,
          titel: "Innenseite mit Ferse",
          was: "Von oben in den Schuh hinein, auf den Fersenbereich.",
          warum: "So sehen wir, wie stark das Innenfutter benutzt wurde."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenaufdruck im Schuh",
          was: "Fotografiere das Etikett innen an der Lasche oder den Aufdruck auf der Sohle.",
          warum: "Daraus lesen wir Größe und Modell selbst ab.",
          modellUnbekannt: true,
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Die kaputte Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So können wir einschätzen, wie stark es den Wert beeinflusst.",
          frage: "riss",
          antworten: ["ja", "unsicher"]
        },
        {
          id: "fersendetail",
          optional: true,
          titel: "Ferse aus der Nähe",
          was: "Fotografiere die durchgescheuerte Stelle im Schuh.",
          warum: "So sehen wir, ob sich das noch aufbereiten lässt.",
          frage: "ferse",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "handschuhe",
      name: "Handschuhe",
      einheit: "Paar",
      marken: ["Bauer", "CCM", "TRUE", "Warrior"],
      brauchtModell: true,
      modellHinweis: "Steht meist außen auf der Stulpe.",
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. 13, Junior M",
      groesseHinweis: "Steht meist innen im Handschuh auf dem Etikett.",
      zustandsfragen: [
        { id: "handflaechen", frage: "Sind Löcher oder größere Risse in den Handflächen?" }
      ],
      fotosStandard: [
        {
          id: "aussen",
          titel: "Beide Handschuhe von außen",
          was: "Beide nebeneinander, Oberseite nach oben.",
          warum: "So erkennen wir Modell, Größe und den allgemeinen Zustand."
        },
        {
          id: "handflaechen",
          optional: true,
          titel: "Die Innenflächen",
          was: "Dreh beide um und fotografiere die Handflächen.",
          warum: "Hier nutzen sich Handschuhe zuerst ab – das entscheidet über den Wert."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenetikett",
          was: "Fotografiere das Etikett innen im Handschuh.",
          warum: "Daraus lesen wir Größe und Modell selbst ab.",
          modellUnbekannt: true,
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Loch oder Riss",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So sehen wir, ob sich das noch reparieren lässt.",
          frage: "handflaechen",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "hose",
      name: "Hose",
      einheit: "Stück",
      marken: ["Bauer", "CCM", "Warrior"],
      brauchtModell: false,
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. Senior M, Junior L",
      groesseHinweis: "Steht meist innen im Bund auf dem Etikett.",
      zustandsfragen: [
        { id: "schaden", frage: "Ist der Stoff irgendwo gerissen?" },
        { id: "verschluss", frage: "Funktionieren Gürtel, Knopf und Reißverschluss noch?", positiv: true }
      ],
      fotosStandard: [
        {
          id: "vorne",
          titel: "Hose von vorne",
          was: "Flach auf den Boden legen und von oben fotografieren.",
          warum: "So erkennen wir Modell, Größe und den allgemeinen Zustand."
        },
        {
          id: "hinten",
          optional: true,
          titel: "Hose von hinten",
          was: "Umdrehen und noch einmal von oben fotografieren.",
          warum: "Hinten sitzen die Polster, die am stärksten beansprucht werden."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenetikett",
          was: "Fotografiere das Etikett innen im Bund.",
          warum: "Daraus lesen wir die Größe selbst ab.",
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Die gerissene Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So können wir einschätzen, wie stark es den Wert beeinflusst.",
          frage: "schaden",
          antworten: ["ja", "unsicher"]
        },
        {
          id: "verschluss_detail",
          optional: true,
          titel: "Bund und Verschluss",
          was: "Fotografiere den Bund mit Knopf und Reißverschluss.",
          warum: "So sehen wir, was genau nicht mehr richtig schließt.",
          frage: "verschluss",
          antworten: ["nein", "unsicher"]
        }
      ]
    },
    {
      id: "schulterschutz",
      name: "Brustpanzer",
      einheit: "Stück",
      marken: ["Bauer", "CCM", "Warrior"],
      brauchtModell: false,
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. Senior L, Junior M",
      groesseHinweis: "Steht meist innen im Nacken auf dem Etikett.",
      zustandsfragen: [
        { id: "polster", frage: "Fehlt irgendwo ein Polster?" },
        { id: "gebrochen", frage: "Ist eine harte Schale gerissen oder gebrochen?" },
        { id: "verschluss", frage: "Halten alle Klettverschlüsse und Gurte noch?", positiv: true }
      ],
      fotosStandard: [
        {
          id: "vorne",
          titel: "Von vorne",
          was: "Flach hinlegen, Vorderseite nach oben.",
          warum: "So erkennen wir Modell, Größe und den allgemeinen Zustand."
        },
        {
          id: "hinten",
          optional: true,
          titel: "Von hinten",
          was: "Umdrehen und die Rückseite fotografieren.",
          warum: "So sehen wir Rückenplatte und Gurte."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenetikett",
          was: "Fotografiere das Etikett innen im Nacken.",
          warum: "Daraus lesen wir die Größe selbst ab.",
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Die betroffene Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So können wir einschätzen, wie stark es den Wert beeinflusst.",
          frage: "polster",
          antworten: ["ja", "unsicher"]
        },
        {
          id: "bruch",
          optional: true,
          titel: "Der Riss in der Schale",
          was: "Fotografiere die gerissene Schale aus der Nähe.",
          warum: "Harte Schalen schützen nur, wenn sie ganz sind – das prüfen wir genau.",
          frage: "gebrochen",
          antworten: ["ja", "unsicher"]
        },
        {
          id: "verschluss_detail",
          optional: true,
          titel: "Die Verschlüsse",
          was: "Fotografiere die Klettverschlüsse und Gurte.",
          warum: "So sehen wir, ob sie sich noch aufbereiten lassen.",
          frage: "verschluss",
          antworten: ["nein", "unsicher"]
        }
      ]
    },
    {
      id: "ellbogenschutz",
      name: "Ellbogenschoner",
      einheit: "Paar",
      marken: ["Bauer", "CCM", "Warrior"],
      brauchtModell: false,
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. Senior M, Junior S",
      groesseHinweis: "Steht meist innen auf dem Etikett.",
      zustandsfragen: [
        { id: "schaden", frage: "Ist die harte Schale gerissen oder fehlt ein Polster?" },
        { id: "verschluss", frage: "Halten die Klettverschlüsse noch?", positiv: true }
      ],
      fotosStandard: [
        {
          id: "gesamt",
          titel: "Beide Schoner von außen",
          was: "Beide nebeneinander legen.",
          warum: "So erkennen wir Modell, Größe und den allgemeinen Zustand."
        },
        {
          id: "innen",
          optional: true,
          titel: "Die Innenseite",
          was: "Dreh beide um, sodass Polster und Klett zu sehen sind.",
          warum: "Hier sehen wir Abnutzung und ob die Verschlüsse noch halten."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenetikett",
          was: "Fotografiere das Etikett innen am Schoner.",
          warum: "Daraus lesen wir die Größe selbst ab.",
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Die betroffene Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So können wir einschätzen, wie stark es den Wert beeinflusst.",
          frage: "schaden",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "schienbeinschutz",
      name: "Schienbeinschoner",
      einheit: "Paar",
      marken: ["Bauer", "CCM", "Warrior"],
      brauchtModell: false,
      brauchtGroesse: true,
      groesseLabel: "Größe",
      groessePlatzhalter: "z. B. 13, Junior M",
      groesseHinweis: "Steht meist innen auf dem Etikett – oft als Zahl wie 13 oder 14.",
      zustandsfragen: [
        { id: "innenfutter", frage: "Ist das herausnehmbare Innenfutter noch vorhanden?", positiv: true },
        { id: "schaden", frage: "Ist die harte Schale gerissen oder gebrochen?" }
      ],
      fotosStandard: [
        {
          id: "vorne",
          titel: "Beide Schoner von vorne",
          was: "Beide nebeneinander legen, harte Schale nach oben.",
          warum: "So erkennen wir Modell, Größe und den allgemeinen Zustand."
        },
        {
          id: "innen",
          optional: true,
          titel: "Die Rückseite",
          was: "Dreh beide um, sodass Innenfutter und Riemen zu sehen sind.",
          warum: "Hier sehen wir Abnutzung und ob alle Riemen noch da sind."
        }
      ],
      fotosBedingt: [
        {
          id: "label",
          titel: "Größenetikett",
          was: "Fotografiere das Etikett innen am Schoner.",
          warum: "Daraus lesen wir die Größe selbst ab.",
          groesseUnbekannt: true
        },
        {
          id: "schaden",
          optional: true,
          titel: "Die gerissene Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "Harte Schalen schützen nur, wenn sie ganz sind – das prüfen wir genau.",
          frage: "schaden",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "schlaeger",
      name: "Schläger",
      einheit: "Stück",
      marken: ["Bauer", "CCM", "TRUE", "Warrior"],
      brauchtModell: true,
      modellHinweis: "Steht meist groß auf dem Schaft.",
      brauchtGroesse: false,
      zustandsfragen: [
        { id: "riss", frage: "Ist der Schläger irgendwo gerissen oder gebrochen?" },
        { id: "gekuerzt", frage: "Wurde der Schläger oben abgesägt oder gekürzt?" }
      ],
      fotosStandard: [
        {
          id: "komplett",
          titel: "Der ganze Schläger",
          was: "Leg ihn auf den Boden und fotografiere ihn komplett.",
          warum: "So erkennen wir Modell, Länge und den allgemeinen Zustand."
        },
        {
          id: "blatt",
          optional: true,
          titel: "Das untere Ende mit Aufdruck",
          was: "Fotografiere die Kelle unten, sodass der Aufdruck lesbar ist.",
          warum: "Dort stehen die technischen Angaben, die wir für die Bewertung brauchen."
        }
      ],
      fotosBedingt: [
        {
          id: "schaden",
          optional: true,
          titel: "Die kaputte Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So können wir einschätzen, ob sich der Schläger noch lohnt.",
          frage: "riss",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "tasche",
      name: "Tasche",
      einheit: "Stück",
      marken: [],
      brauchtModell: false,
      brauchtGroesse: false,
      zustandsfragen: [
        { id: "schaden", frage: "Sind Reißverschlüsse, Gurte oder Rollen kaputt?" }
      ],
      fotosStandard: [
        {
          id: "gesamt",
          titel: "Die Tasche von außen",
          was: "Geschlossen, von der Seite fotografiert.",
          warum: "So erkennen wir Größe, Art und den allgemeinen Zustand."
        }
      ],
      fotosBedingt: [
        {
          id: "schaden",
          optional: true,
          titel: "Die kaputte Stelle",
          was: "Fotografiere die Stelle aus der Nähe.",
          warum: "So sehen wir, ob sich das noch reparieren lässt.",
          frage: "schaden",
          antworten: ["ja", "unsicher"]
        }
      ]
    },
    {
      id: "torwartausruestung",
      name: "Torwart-Ausrüstung",
      einheit: "Stück",
      spezialfall: true,
      hinweis: "Torwart-Ausrüstung ist speziell — wir schauen sie uns nach dem Absenden persönlich an, statt hier automatisch abzufragen.",
      fotosStandard: [
        {
          id: "gesamt",
          titel: "Alle Teile zusammen",
          was: "Leg alles nebeneinander und fotografiere es bei gutem Licht.",
          warum: "So sehen wir auf einen Blick, was dabei ist."
        },
        {
          id: "label",
          optional: true,
          titel: "Größe oder Etikett",
          was: "Fotografiere ein Etikett, falls du eines findest.",
          warum: "Daraus lesen wir Größe und Modell selbst ab."
        }
      ],
      fotosBedingt: []
    },
    {
      id: "sonstiges",
      name: "Sonstiges",
      einheit: "Stück",
      spezialfall: true,
      hinweis: "Kurz beschreiben reicht — den Rest klären wir nach dem Absenden mit dir.",
      fotosStandard: [
        {
          id: "gesamt",
          titel: "Der Artikel",
          was: "Fotografiere ihn komplett bei gutem Licht.",
          warum: "So sehen wir, worum es geht."
        }
      ],
      fotosBedingt: []
    }
  ];

  function kategorieFinden(id) {
    for (var i = 0; i < KATEGORIEN.length; i++) {
      if (KATEGORIEN[i].id === id) return KATEGORIEN[i];
    }
    return null;
  }

  window.AsVerkaufenDaten = {
    KATEGORIEN: KATEGORIEN,
    kategorieFinden: kategorieFinden
  };
})();
